<template>
  <div class="redirect-button__wrapper">
    <div class="redirect-button" v-on:click="redirectToTypeForm" v-wave="{color: '#005252',initialOpacity: 0.5,easing: 'ease-in'}">
      Jetzt Fahrzeug verkaufen
    </div>
  </div>
</template>
<script>
export default {
  props: ['token'],
  methods: {
    redirectToTypeForm () {      
      window.location.href = `/auto-verkaufen/verkauf-1/${this.token}`;
    }
  }
}
</script>
<style lang="scss" scoped>
  .redirect-button {
    display: inline-block;
    background-color: #c0141b;
    color: #fff;
    padding: 15px 30px;
    font-weight: 700;
    border-radius: 50px;
    cursor: pointer;
    transition: background-color .2s;

    &:hover {
      background-color: #ab1116;
    }
    
    &__wrapper {
      margin: 35px 0;
      padding: 40px;
      border-radius: 20px;
      background-color: #F7F7F7;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TypeFormRedirect.vue